<div class="field-icon" [hidden]="field.type === LayoutFieldType.PageHeader">
    <i class="{{ layoutSchema.iconClass }} i32"></i>
</div>
